import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  ObtenerReporteTablaAmortizacionME,
  ObtenerReporteTablaPagosPrestamosME,
  PrestamoInformacionModeloMLS,
  PrestamoService,
} from 'src/app/open-api';
import { UserModel } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import * as printjs from 'print-js';
import { jsPDF } from 'jspdf';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
var htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-prestamo-modal',
  templateUrl: './prestamo-modal.component.html',
  styleUrls: ['./prestamo-modal.component.scss'],
})
export class PrestamoModalComponent implements OnInit {
  @Input() prestamo?: PrestamoInformacionModeloMLS;
  @Input() reporte?: string;
  @ViewChild('modal-content-hmtl') content?: ElementRef;
  usuario?: UserModel;
  contenido?: SafeHtml;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private prestamoService: PrestamoService,
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.authService.user.subscribe((usuario) => {
      this.usuario = usuario;
    });
    this.ObtenerInformacion();
  }

  ObtenerInformacion(): void {
    switch (this.reporte) {
      case 'Pago':
        const parametroPago: ObtenerReporteTablaPagosPrestamosME = {
          secuencialPrestamo: this.prestamo?.secuencial,
        };
        this.prestamoService
          .apiV10PrestamoObtenerReporteTablaPagosPrestamosPost(parametroPago)
          .subscribe((respuesta) => {
            const html =
              respuesta.reporteTablaPagosPrestamos
              ?.replace('Judiciales', 'Judic.')
              ?.replace('.a24{', '.a24{letter-spacing: 1px;')
              ?.replace('.a20{', '.a20{letter-spacing: 1px;')
              ?.replace('.a37{', '.a37{letter-spacing: 1px;')
              ?.replace('.a54{', '.a54{letter-spacing: 1px;')
              ?.replace('.a71{', '.a71{letter-spacing: 1px;')
              ?.replace('.a88{', '.a88{letter-spacing: 1px;')
              ?.replace('.a105{', '.a105{letter-spacing: 1px;')
              ?.replace('.a28{', '.a28{letter-spacing: 1px;')
              ?.replace('.a45{', '.a45{letter-spacing: 1px;')
              ?.replace('.a62{', '.a62{letter-spacing: 1px;')
              ?.replace('.a79{', '.a79{letter-spacing: 1px;')
              ?.replace('.a96{', '.a96{letter-spacing: 1px;')
              ?.replace('.a113{', '.a113{letter-spacing: 1px;')
              ?.replace('.a41{', '.a41{letter-spacing: 1px;')
              ?.replace('.a58{', '.a58{letter-spacing: 1px;') ||
              'No hay información para mostrar.';
            this.contenido = this.sanitizer.bypassSecurityTrustHtml(html);
            this.spinner.hide();
          });
        break;
      case 'Amortización':
        const parametro: ObtenerReporteTablaAmortizacionME = {
          secuencialPrestamo: this.prestamo?.secuencial,
          secuencialEmpresa: this.usuario?.secuencialEmpresa,
        };
        this.prestamoService
          .apiV10PrestamoObtenerReporteTablaAmortizacionPost(parametro)
          .subscribe((respuesta) => {
            const html =
              respuesta.reporteTablaAmortizacion
              ?.replace('.a22{', '.a22{letter-spacing: 2px;')
              ?.replace('.a85{', '.a85{letter-spacing: 1px;')
              ?.replace('.a152{', '.a152{letter-spacing: 1px;')
              ?.replace('.a329{', '.a329{letter-spacing: 1px;')
              ?.replace('.a361{', '.a361{letter-spacing: 1px;')
              ?.replace('.a63{', '.a63{letter-spacing: 1px;')
              ?.replace('.a72{', '.a72{letter-spacing: 1px;')
              ?.replace('.a81{', '.a81{letter-spacing: 1px;')
              ?.replace('.a25{', '.a25{letter-spacing: 2px;')
              ?.replace('.a133{', '.a133{letter-spacing: 1px;')
              ?.replace('.a133{', '.a133{letter-spacing: 1px;')
              ?.replace('.a148{', '.a148{letter-spacing: 1px;')
              ?.replace('.a163{', '.a163{letter-spacing: 1px;')
              ?.replace('.a193{', '.a193{letter-spacing: 1px;')
              ?.replace('.a223{', '.a223{letter-spacing: 1px;')
              ?.replace('.a253{', '.a253{letter-spacing: 1px;')
              ?.replace('.a283{', '.a283{letter-spacing: 1px;')
              ?.replace('.a321{', '.a321{letter-spacing: 1px;')
              ?.replace('.a98{', '.a98{letter-spacing: 1px;')
              ?.replace('.a116{', '.a116{letter-spacing: 1px;')
              ?.replace('.a178{', '.a178{letter-spacing: 1px;')
              ?.replace('.a208{', '.a208{letter-spacing: 1px;')
              ?.replace('.a238{', '.a238{letter-spacing: 1px;')
              ?.replace('.a268{', '.a268{letter-spacing: 1px;')
              ?.replace('.a35{', '.a35{letter-spacing: 1px;')
              ?.replace('.a44{', '.a44{letter-spacing: 1px;')
              ?.replace('.a48{', '.a48{letter-spacing: 1px;')
              ?.replace('.a55{', '.a55{letter-spacing: 1px;')
              ?.replace('.a64{', '.a64{letter-spacing: 1px;')
              ?.replace('.a11{', '.a11{letter-spacing: 1px;')
              ?.replace('.a119{', '.a119{letter-spacing: 1px;')
              ?.replace('.a292{', '.a292{letter-spacing: 1px;')
              ?.replace('.a296{', '.a296{letter-spacing: 1px;')
              ?.replace('.a328{', '.a328{letter-spacing: 1px;')
              ?.replace('.a67{', '.a67{letter-spacing: 1px;') ||
              'No hay información para mostrar.';
            this.contenido = this.sanitizer.bypassSecurityTrustHtml(html);
            this.spinner.hide();
          });
        break;
    }
  }

  Imprimir(): void {
    var titlePage = '';
    switch (this.reporte) {
      case 'Pago':
        titlePage = 'Canal Web - Riobamba Reporte Pago';
        break;
      case 'Amortización':
        titlePage = 'Canal Web - Riobamba Reporte Amortización';
        break;
    }
    printjs({
      printable: 'modal-content-hmtl',
      type: 'html',
      style: '@page { size: A4 landscape; margin: 18px; }',
      header: titlePage,
    });
  }

  Descargar() : void {
    this.spinner.show();
    var titlePage = '';
    switch (this.reporte) {
      case 'Pago':
        titlePage = 'Canal Web - Riobamba Reporte Pago';
        break;
      case 'Amortización':
        titlePage = 'Canal Web - Riobamba Reporte Amortización';
        break;
    }

    const doc = new jsPDF('landscape', 'mm', 'a4');
    const htmlDoc = document.getElementById('modal-content-hmtl');

    doc.html(htmlDoc?.innerHTML || '', {
      callback: (doc) => {
        doc.save(titlePage+'.pdf');
        this.spinner.hide();
      },
      width: 210,
      windowWidth: 800,
      x: 10,
      y: 10,
    });
  }
}
